/**
 * Coming Soon Widget Component
 *
 * Feature: 136-dashboard-alignment
 * Description: Placeholder widget for dashboard sections not yet implemented.
 *   ManagerDashboard uses this for client breakdown and SLA details.
 * Constitution: v1.12.0 — Principle XXXVII (Code Header Standards)
 */

import React from 'react';
import clsx from 'clsx';

interface ComingSoonWidgetProps {
  /** Widget title */
  title: string;
  /** Short description of the planned feature */
  description?: string;
  /** Optional icon element rendered above the text */
  icon?: React.ReactNode;
  /** Optional CSS class */
  className?: string;
}

/**
 * Placeholder card for features not yet wired to live data.
 * Shows a construction icon, title, and optional description.
 */
export const ComingSoonWidget: React.FC<ComingSoonWidgetProps> = ({
  title,
  description = 'This feature is under development and will be available soon.',
  icon,
  className,
}) => (
  <div
    className={clsx(
      'bg-[var(--color-bg-card)] rounded-lg border border-[var(--color-border)] p-4',
      className
    )}
  >
    <h3 className="text-base font-semibold text-[var(--color-text-primary)] mb-4">
      {title}
    </h3>

    <div className="flex flex-col items-center justify-center py-8 text-center">
      {icon ?? (
        <svg
          className="w-10 h-10 text-[var(--color-text-secondary)] mb-3"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M11.42 15.17l-5.42 3.22V6.34a2 2 0 012-2h8a2 2 0 012 2v12.05l-5.42-3.22a1 1 0 00-1.16 0z"
          />
        </svg>
      )}

      <p className="text-sm font-medium text-[var(--color-text-secondary)] mb-1">
        Coming Soon
      </p>
      <p className="text-xs text-[var(--color-text-secondary)] max-w-xs">
        {description}
      </p>
    </div>
  </div>
);

export default ComingSoonWidget;
